import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "gt-simple-breadcrumbs" }
const _hoisted_2 = { class: "gt-simple-breadcrumbs__element" }
const _hoisted_3 = { class: "gt-simple-breadcrumbs__text ds-caption ds-caption--size_2md ds-caption--size_xl-xl ds-caption--medium ds-caption--appearance_nowrap" }
const _hoisted_4 = { class: "gt-simple-breadcrumbs__text" }
const _hoisted_5 = { class: "ds-caption ds-caption--size_2md ds-caption--size_xl-xl ds-caption--medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_arrow_right = _resolveComponent("i-arrow-right")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.currentTitle)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "gt-simple-breadcrumbs__back-button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.parentRouteName ? $setup.router.push({ name: $setup.parentRouteName, params: { id: $setup.objectId || null }  }) : $setup.router.back()), ["prevent"]))
          }, [
            _createVNode(_component_i_arrow_right)
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString($setup.currentTitle), 1)
          ])
        ], 64))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.breadcrumbs, (breadcrumb, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "gt-simple-breadcrumbs__element",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.labels[breadcrumb.name]), 1)
            ])
          ]))
        }), 128))
  ]))
}